import { render, staticRenderFns } from "./ClientAddressForm.vue?vue&type=template&id=4b752a2b&scoped=true"
import script from "./ClientAddressForm.vue?vue&type=script&lang=ts"
export * from "./ClientAddressForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientAddressForm.vue?vue&type=style&index=0&id=4b752a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b752a2b",
  null
  
)

export default component.exports